import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";

const mutations = {
  [types.GET_TASKCATEGORIES_BEGIN](state) {
    state.taskCategoriesGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_TASKCATEGORIES_SUCCESS](state, taskCategories) {
    state.taskCategoriesGetError = null;
    state.taskCategories = taskCategories;
    state.taskCategoriesGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_TASKCATEGORIES_ERROR](state, err) {
    state.taskCategoriesGetState = API_STATES.REQUEST_ERROR;
    state.taskCategoriesGetError = err;
  },
  
  [types.DELETE_TASKCATEGORY_BEGIN](state) {
    state.taskCategoryDeleteState = API_STATES.REQUEST_PENDING;
  },
  [types.DELETE_TASKCATEGORY_SUCCESS](state) {
    state.taskCategoryDeleteError = null;
    state.taskCategoryDeleteState = API_STATES.REQUEST_SUCCESS;
  },
  [types.DELETE_TASKCATEGORY_ERROR](state, err) {
    state.taskCategoryDeleteState = API_STATES.REQUEST_ERROR;
    state.taskCategoryDeleteError = err;
  },

  [types.CREATE_TASKCATEGORY_BEGIN](state) {
    state.taskCategoryCreateState = API_STATES.REQUEST_PENDING
  },
  [types.CREATE_TASKCATEGORY_SUCCESS](state, data) {
    state.taskCategoryCreateError = null
    state.taskCategory = data
    state.taskCategoryCreateState = API_STATES.REQUEST_SUCCESS
  },
  [types.CREATE_TASKCATEGORY_ERROR](state, err) {
    state.taskCategoryCreateState = API_STATES.REQUEST_ERROR
    state.taskCategoryCreateError = err
  },

  [types.UPDATE_TASKCATEGORY_BEGIN](state) {
    state.taskCategoryUpdateState = API_STATES.REQUEST_PENDING
  },
  [types.UPDATE_TASKCATEGORY_SUCCESS](state, data) {
    state.taskCategoryUpdateError = null
    state.taskCategory = data
    state.taskCategoryUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [types.UPDATE_TASKCATEGORY_ERROR](state, err) {
    state.taskCategoryUpdateState = API_STATES.REQUEST_ERROR
    state.taskCategoryUpdateError = err
  }
};

export default mutations;